/** Сontains all data formats known to us */
export var DataTransferType;
(function (DataTransferType) {
    DataTransferType["Text"] = "text/plain";
    DataTransferType["Html"] = "text/html";
    DataTransferType["Yfm"] = "text/yfm";
    DataTransferType["UriList"] = "text/uri-list";
    DataTransferType["VSCodeData"] = "vscode-editor-data";
    DataTransferType["Files"] = "Files";
})(DataTransferType || (DataTransferType = {}));
export function isFilesOnly({ types }) {
    return types.length === 1 && types[0] === DataTransferType.Files;
}
export function isFilesFromHtml({ types }) {
    return (types.length === 2 &&
        types.includes(DataTransferType.Files) &&
        types.includes(DataTransferType.Html));
}
export function isImageFile(file) {
    return file.type.startsWith('image/');
}
